import { z } from 'my-zod'
import { makeValidator } from '../../internal/validator'
import { customerSubscriptionModel } from './customer-subscription-model'

export const customerSubscriptionCancellationFragment = customerSubscriptionModel.pick({
  cancellationReasonCode: true,
  cancellationReasonDescription: true
})

export type customerSubscriptionCancellationFragment = z.infer<typeof customerSubscriptionCancellationFragment>

export const validateCustomerSubscriptionCancellationFragment = makeValidator<customerSubscriptionCancellationFragment>(
  (input, error) => {
    if (!input.cancellationReasonCode) {
      error('Required', ['cancellationReasonCode'])
    }
    if (
      input.cancellationReasonCode &&
      input.cancellationReasonCode.includes(':Other') &&
      !input.cancellationReasonDescription
    ) {
      error('Required', ['cancellationReasonDescription'])
    }
  }
)
